import { render, staticRenderFns } from "./GenerateProductForm.vue?vue&type=template&id=4b4b8666&scoped=true&"
import script from "./GenerateProductForm.vue?vue&type=script&lang=js&"
export * from "./GenerateProductForm.vue?vue&type=script&lang=js&"
import style0 from "./GenerateProductForm.vue?vue&type=style&index=0&id=4b4b8666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b8666",
  null
  
)

export default component.exports